import { useRef, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Upload, X } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ImageUploader = ({ value, onChange, label, testId }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
    if (!allowed.includes(file.type)) {
      toast.error('Only JPG, PNG, GIF, WebP, SVG allowed');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error('Max 10MB');
      return;
    }

    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);

    try {
      const res = await axios.post(`${API}/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      // Save relative path — works across any domain (preview, production, future domains)
      onChange(res.data.url);
      toast.success('Image uploaded!');
    } catch {
      toast.error('Upload failed');
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div className="space-y-2">
      {value && (
        <div className="relative inline-block">
          <img src={value} alt="Preview" className="h-20 object-cover rounded border border-gray-200" />
          <button type="button" onClick={() => onChange('')}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
            data-testid={`${testId}-remove`}>
            <X size={12} />
          </button>
        </div>
      )}
      <div className="flex items-center gap-2">
        <input ref={fileRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" data-testid={`${testId}-file`} />
        <Button type="button" onClick={() => fileRef.current?.click()} variant="outline"
          className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white h-8 text-xs px-3"
          disabled={uploading} data-testid={`${testId}-upload-btn`}>
          {uploading ? <><div className="animate-spin rounded-full h-3 w-3 border-2 border-current border-t-transparent mr-1" /> Uploading...</> : <><Upload size={14} className="mr-1" /> From Device</>}
        </Button>
        <span className="text-gray-400 text-xs">or</span>
        <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="Paste URL" className="flex-1 h-8 text-xs" data-testid={`${testId}-url`} />
      </div>
    </div>
  );
};
